import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tooltip } from 'antd';
import React from 'react';

interface IConfirmProps {
  disabled?: boolean;
  onRemove: () => void;
  children: React.ReactElement;
}

/** Removing a service always asks: its labour and parts go with it. */
export const RemoveServiceConfirm: React.FC<IConfirmProps> = ({ disabled, onRemove, children }) => (
  <Popconfirm
    title="Remove this service from the job?"
    description="Its labour and parts come off the job when you save."
    okText="Remove"
    okButtonProps={{ danger: true }}
    onConfirm={onRemove}
    disabled={disabled}
  >
    {children}
  </Popconfirm>
);

interface IProps {
  disabled?: boolean;
  onRemove: () => void;
  /** The phone's full-width button rather than the small one in the desktop grid's last column. */
  block?: boolean;
  /** Just the bin, for the desktop grid on a small screen. */
  iconOnly?: boolean;
}

export const RemoveServiceButton: React.FC<IProps> = ({ disabled, onRemove, block, iconOnly }) => (
  <RemoveServiceConfirm disabled={disabled} onRemove={onRemove}>
    {iconOnly ? (
      <Tooltip title={disabled ? undefined : 'Remove service'}>
        <Button
          type="text"
          size="small"
          danger
          aria-label="Remove service"
          icon={<DeleteOutlined />}
          disabled={disabled}
        />
      </Tooltip>
    ) : (
      <Button
        block={block}
        type={block ? 'default' : 'text'}
        size={block ? 'middle' : 'small'}
        danger
        icon={<DeleteOutlined />}
        disabled={disabled}
      >
        {block ? 'Remove service' : 'Remove'}
      </Button>
    )}
  </RemoveServiceConfirm>
);
